// extracted by mini-css-extract-plugin
export var container = "video-expander-module--container--KsP6s";
export var spacer = "video-expander-module--spacer--amcPB";
export var zoomElement = "video-expander-module--zoomElement--cFoxP";